@if (gatewayOrder) {
  <div class="gateway-order-detail-container">
    <h3>Gateway Order #{{gatewayOrder.gatewayOrderId}}</h3>
    <div class="gateway-order-detail">
      <div>
        Name: {{gatewayOrder.orderName}}
        <mat-icon aria-hidden="false"
                  aria-label="Edit Gateway Order Name"
                  class="clickable gateway-order-edit-name"
                  matTooltip="Edit Gateway Order Name"
                  (click)="editGatewayOrderName()">edit</mat-icon>
      </div>
      <div>Type: {{gatewayOrder.gatewayOrderType}}</div>
      <div>Gateway Server Environment: {{environmentKey}}</div>
      <div>Hub Environment: {{hubEnvironmentLabel}}</div>
      <div>Created: {{gatewayOrder.createdDateTime}}</div>
      <div>Created By: {{gatewayOrder.creatorEmail}}</div>
    </div>

    <div class="gateway-order-upload">
      <input #fileInput class="form-control gateway-order-file-input" type="file" accept=".csv,text/csv" (change)="onFileSelected($event)" [disabled]="uploadingDevices">
      <button class="btn btn-outline-primary" type="button" (click)="uploadDevices(fileInput)" [disabled]="!selectedFile || uploadingDevices">
        @if (uploadingDevices) {
          UPLOADING...
        } @else {
          UPLOAD CSV
        }
      </button>
    </div>

    @if (uploadingDevices) {
      <div class="gateway-order-upload-status">Processing file...</div>
    }

    @if (importSuccess) {
      <div class="alert alert-success">{{importSuccess}}</div>
    }

    @if (importError) {
      <div class="alert alert-danger">{{importError}}</div>
    }

    <div class="gateway-order-devices-heading">
      <h3>Gateway Order Devices</h3>
      <span class="gateway-order-refresh-icon">
        <mat-icon aria-hidden="false"
                  aria-label="Refresh Gateway Order Devices"
                  class="clickable"
                  matTooltip="Refresh Gateway Order Devices."
                  (click)="refreshDevices()">refresh</mat-icon>
      </span>
      @if (refreshDevicesFailed) {
        <span class="gateway-order-refresh-failed">Gateway Order Devices refresh failed. Please try again.</span>
      }
    </div>

    <table class="gateway-order-device-table">
      <thead>
        <tr>
          <th><input type="checkbox"
                     [checked]="allActionableDevicesSelected()"
                     [disabled]="!hasActionableDevices()"
                     (change)="selectAllActionableDevices($event)"></th>
          <th>IMEI</th>
          <th>Status</th>
          <th>Device Name</th>
          <th>OEM Serial</th>
          <th>Device Type</th>
          <th>Secure inReach</th>
          <th>TAK Group</th>
          <th>Backhaul Registration</th>
          <th>Team Tracking</th>
          <th>Error Message</th>
          <th>JSON</th>
        </tr>
      </thead>
      <tbody>
        @for (device of gatewayOrder.gatewayOrderDevices || []; track device.gatewayOrderDeviceId) {
          <tr>
            <td>
              <input type="checkbox"
                     name="{{device.imei}}"
                     [checked]="isDeviceSelected(device)"
                     [disabled]="!isActionableDevice(device)"
                     (change)="selectDevice(device, $event)">
            </td>
            <td>{{device.imei}}</td>
            <td>{{device.gatewayOrderDeviceStatus}}</td>
            <td>{{device.gatewayDeviceName}}</td>
            <td>{{device.hubOemSerial}}</td>
            <td>{{device.hubDeviceType}}</td>
            <td>{{device.secureInReach}}</td>
            <td>{{device.gatewayTakGroupName}}</td>
            <td>{{device.backhaulDeviceRegistration}}</td>
            <td>{{device.teamTrackingEnabled}}</td>
            <td class="gateway-order-device-error-cell">{{device.errorMessage}}</td>
            <td>
              <mat-icon [cdkCopyToClipboard]="copyDeviceJsonToClipboard(device)"
                        aria-hidden="false"
                        aria-label="Copy device JSON"
                        class="clickable"
                        matTooltip="Copy full object as JSON"
                        (click)="confirmDeviceJsonCopied()">content_copy</mat-icon>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="gateway-order-device-actions">
      <button class="mb-3 btn btn-outline-danger"
              [disabled]="!devicesSelected() || deletingSelectedDevices || retryingSelectedDevices"
              (click)="deleteSelectedDevices()">
        @if (deletingSelectedDevices) {
          DELETING...
        } @else {
          Delete selected device(s)
        }
      </button>

      <button class="mb-3 btn btn-outline-primary"
              [disabled]="!devicesSelected() || retryingSelectedDevices || deletingSelectedDevices"
              (click)="createOrRetrySelectedDevices()">
        @if (retryingSelectedDevices) {
          UPDATING...
        } @else {
          Create/Retry selected device(s)
        }
      </button>

      <button class="mb-3 btn btn-outline-primary"
              [disabled]="!hasSecureInReachDevices() || downloadingSecureInReachConfigs"
              (click)="downloadSecureInReachConfigs()">
        @if (downloadingSecureInReachConfigs) {
          DOWNLOADING...
        } @else {
          Download secure inReach config(s)
        }
      </button>
    </div>

    @if (retryDevicesError) {
      <div class="alert alert-danger">{{retryDevicesError}}</div>
    }

    @if (deleteDevicesError) {
      <div class="alert alert-danger">{{deleteDevicesError}}</div>
    }

    @if (downloadSecureInReachConfigsError) {
      <div class="alert alert-danger">{{downloadSecureInReachConfigsError}}</div>
    }
  </div>
}
